import { heroFeatures } from "../data/content"

interface Props {
  scrollToVideo?: () => void
}

export function GoHeroSection({ scrollToVideo }: Props) {
  return (
    <div className="mk-hero-banner">
      <div className="mk-hero-banner-inner">
        <img
          src="/marketing/go/hero-vector.png"
          alt=""
          className="mk-hero-banner-bg"
        />

        <div className="mk-hero-banner-content">
          {/* Join chip */}
          <div className="mk-hero-join-chip">
            <span className="icon">✦</span>
            Join To To-Do
          </div>

          <h2 className="mk-hero-headline">
            Ready to get your life in sync?
          </h2>
          <p className="mk-hero-subtitle">
            Whether you're juggling family, work, or just trying to keep your
            head above water, To To-Do is your everyday safety net.
          </p>

          <div style={{ display: "flex", gap: 20, width: "100%", maxWidth: 600 }}>
            <button className="mk-cta mk-cta-white" onClick={scrollToVideo}>
              Watch demo
            </button>
            <a href="https://totodo.app/" className="mk-cta mk-cta-transparent">
              Start for free
            </a>
          </div>
        </div>

        {/* Feature cards at bottom */}
        <div className="mk-hero-features-grid">
          {heroFeatures.map((f) => (
            <div key={f.text} className="mk-hero-feature-card">
              <img src={f.iconSrc} alt="" />
              {f.text}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
